import { PayMode } from '../../Shared/invoice-enum'
import { User } from './User';
export class PaymentDetail {
  PaymentDetaildId:number;
  InvoiceId: number;
  PaidBy: PayMode;
  PaidAmount: number;
  BalanceAmount: number;
  PaymentRecievedBy: User;
  PaymentRecievedOn: Date;
}
